import { Link } from "react-router-dom";
import { Button } from "../../components/forms/Form";
import "./ChangePasswordForm.css";
const formInput = (props) => {
  return (
    <input
      {...props.value}
      placeholder={props.placeholder}
      type="password"
      className="change-password-form-input form-item"
      onChange={(event) =>
        props.handleChangeInput(props.target, event.target.value)
      }
    ></input>
  );
};
export const ChangePassword = (props) => {
  // console.log("modal", props);
  return (
    <div className="change-password-form">
      {formInput({
        placeholder: "Inserire la password attuale",
        target: "oldPassword",
        handleChangeInput: props.handleChangeInput,
      })}
      {props.error && (
        <p style={{ color: "red", fontWeight: "600" }}>
          {props.error.response.data.message}
        </p>
      )}
      {/* <p className="form-item">
        <Link to="/newPasswordRequest">
          Hai dimenticato la password o la email?
        </Link>
      </p> */}

      {formInput({
        placeholder: "Inserire la nuova password",
        target: "password",
        handleChangeInput: props.handleChangeInput,
      })}
      {formInput({
        placeholder: "Ripetere la nuova password",
        target: "repeatPassword",
        handleChangeInput: props.handleChangeInput,
      })}
      <div className="change-password-button-container">
        <Button
          text={"ANNULLA"}
          className={"exit-button"}
          handleSubmit={props.togglePopUp}
        />
        <Button
          text={"SALVA"}
          handleSubmit={props.handleSubmit}
          disabled={props.disabled}
        />
      </div>
    </div>
  );
};
